import { useEffect, useState } from "react";
import styles from "../articles.module.css";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-smart-toaster";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

const ArticleFilter = ({ filterData, setFilterData, setPage }) => {
    const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    useEffect(() => {
        const getPropertyList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList((response.data?.data || []).map(item => ({ value: item?.id, label: item?.name })));
            }).catch((error) => {
                console.error('[KnowledgeBase] Failed to load property list for filter', error);
                toast.error(error?.response?.data?.message || 'Unable to load properties. Please try again.');
                setPropertyList([]);
            });
        }

        getPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const getCategoryList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_RESOURCE_API_URL + "v1/article-category-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setCategoryList((response.data?.data || []).map(item => ({ value: item?.id, label: item?.title })));
            }).catch((error) => {
                console.error('[KnowledgeBase] Failed to load category list for filter', error);
                toast.error(error?.response?.data?.message || 'Unable to load categories. Please try again.');
                setCategoryList([]);
            });
        }

        getCategoryList();
    }, [getAccessTokenSilently]);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Select Property"
                        options={propertyList}
                        value={filterData?.property}
                        onChange={(value) => {
                            setFilterData(prev => ({ ...prev, property: value }));
                            setPage(0);
                        }}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Select Category"
                        options={categoryList}
                        value={filterData?.category}
                        onChange={(value) => {
                            setFilterData(prev => ({ ...prev, category: value }));
                            setPage(0);
                        }}
                    />
                </div>
            </div>
            <button className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}><Filter /></button>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("knowledgebase:create") > -1 && <Link to={"/resources/knowledge-bases/add"} className={`${styles.AddNoteBu}`}><Plus /> <span>Article</span></Link>}
        </div>
    </div>)
}

export default ArticleFilter;